import type { FinalCtaContent } from "../i18n/types";

export function renderFinalCTA(t: FinalCtaContent): HTMLElement {
  const root = document.createElement("section");
  root.className = "section section--tight finalcta";
  root.id = "contact";
  root.innerHTML = `
    <div class="page">
      <div class="finalcta__inner" data-reveal>
        <div class="finalcta__drafting" aria-hidden="true">
          <span>${t.draftingLabels[0]}</span>
          <span>${t.draftingLabels[1]}</span>
          <span>${t.draftingLabels[2]}</span>
        </div>
        <div class="finalcta__content">
          <h2 class="finalcta__title">${t.titleLine1}<br>${t.titleLine2}</h2>
          <p class="finalcta__subtitle">
            ${t.subtitle}
          </p>
          <div class="finalcta__actions">
            <a class="btn btn--primary btn--primary--lg" href="https://cloud.sdu.dk/app">${t.ctaPrimary}</a>
            <a class="btn btn--ghost btn--primary--lg" href="mailto:escience@sdu.dk">${t.ctaSecondary}</a>
          </div>
        </div>
      </div>
    </div>
  `;
  return root;
}
